import { Box, Spinner, Text, Button, useDisclosure } from '@chakra-ui/react';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SettingsLayout from 'presentation/layout/modules/settings/SettingsLayout';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import AppCard from 'presentation/components/shared/card/AppCard';
import { useParams } from 'react-router-dom';
import { useFetchNotificationQuery } from 'rtkQuery/sharespro/queries/notifications';
import moment from 'moment';
import HtmlContentBox from 'presentation/components/shared/HtmlContentBox/HtmlContentBox';
import RequestNotificationModal from 'presentation/containers/modules/notifications/RequestNotificationModal';

interface NotificationModalData {
  notificationId: string;
  title: string;
  text: string;
}

const NotificationDetailPage: FC = () => {
  const { t } = useTranslation();
  const params = useParams();
  const id = params.id as string;

  const { data, isFetching } = useFetchNotificationQuery({ id });
  const [notificationModalData, setNotificationModalData] = useState<NotificationModalData | null>(null);

  const {
    isOpen: isNotificationRequestOpen,
    onClose: onNotificationRequestClose,
    onOpen: onNotificationRequestOpen,
  } = useDisclosure();

  return (
    <SettingsLayout>
      <GridHeading>{t('notifications')}</GridHeading>
      <AppCard w="100%" p="20px" overflow="hidden">
        {isFetching && <Spinner />}
        {data && (
          <Box>
            <Text fontWeight={700} fontSize="lg">{data.title}</Text>
            {data.content ? (
              <HtmlContentBox content={data.content} mt={2} px={4} />
            ) : (
              <Text color="gray.600" mt={2}>{data.body}</Text>
            )}
            <Text fontSize="sm" color="gray.500" mt={3}>
              {moment(data.createdAt).format('DD.MM.YYYY HH:mm')}
            </Text>
            {data.contentAction && (
              <Button
                mt={4}
                colorScheme="blue"
                onClick={() => {
                  setNotificationModalData({
                    notificationId: data.id,
                    title: t('submitRequest'),
                    text: t('requestCallManagerNotificationText'),
                  });
                  onNotificationRequestOpen();
                }}
              >
                {t('submitRequest')}
              </Button>
            )}
          </Box>
        )}
      </AppCard>
      {notificationModalData && (
        <RequestNotificationModal
          text={notificationModalData.text}
          title={notificationModalData.title}
          isOpen={isNotificationRequestOpen}
          onClose={onNotificationRequestClose}
          notificationId={notificationModalData.notificationId}
        />
      )}
    </SettingsLayout>
  );
};

export default NotificationDetailPage;
